import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography
} from '@material-ui/core'
import CheckIcon from '@material-ui/icons/Check'
import { Pagination } from '@material-ui/lab'

import clsx from 'clsx'
import { useEffect, useState } from 'react'

import { ERROR_COLORS, SUCCESS_COLORS } from 'asterX-UI'
import AsterButton from 'asterX-UI/Buttons/AsterButton'
import AsterChip from 'asterX-UI/DataDisplay/AsterChip'
import { CloseIcon } from 'asterX-UI/Icons'
import { EditIcon } from 'asterX-UI/Icons/EditIcon'
import StandardTable from 'asterX-UI/Table/StandardTable'

import { colorStatusesByCode, OKTELL } from 'constants/deals'
import { useAuthStore } from 'context/AuthStore'
import { useHomeStoreRop } from 'context/HomeStore/Rop'
import { useResErrors, useRoutes } from 'hooks'
import { AuthService, SalesService } from 'lib/api'
import { DEAL_VIEW_PATH, HOME_PATH } from 'routes/constants.routes'
import { tableStatusBtns } from './const'
import { useStyles } from './rop-wl-table.styles'

export const RopWLTable = () => {
  const classes = useStyles()
  const router = useRoutes()
  const { authStore } = useAuthStore()
  const { standardCheck } = useResErrors()

  const {
    homeStore: { approveStatus, wlCount, wlList, wlTab, pagination },
    homeStoreFunc: {
      getSaleList,
      onPaginationChange,
      setApproveStatus,
      setWlTab
    }
  } = useHomeStoreRop()

  const [isManagersListDialogOpen, setIsManagersListDialogOpen] =
    useState(false)
  const [usersList, setUsersList] = useState([])
  const [selectedManager, setSelectedManager] = useState()
  const [selectedWorksheet, setSelectedWorkSheet] = useState({})
  const [loading, setLoading] = useState(false)

  const columns = [
    'id',
    'Номер РЛ',
    'Имя',
    'VIN-код',
    'Тип создания',
    'Статус октелл',
    'Подвод',
    'Трейд-ин',
    'Новый контракт',
    'Визит',
    'Сотрудник',
    'Статус'
  ]

  const openManagersList = worksheet => event => {
    event.stopPropagation()
    setSelectedWorkSheet(worksheet)
    setIsManagersListDialogOpen(true)
  }

  const rows = wlList
    ? wlList?.map(e => {
        return [
          e.id,
          e.globalId,
          [e.client.firstName, e.client.lastName].join(' '),
          e.selectedCarsForSale?.length
            ? e.selectedCarsForSale.map(e => e?.vin || '').join(', ')
            : '',
          e.creationType,
          !!e?.callResult ? (
            e.callResult
          ) : (
            <CloseIcon style={{ color: ERROR_COLORS[700], width: 10 }} />
          ),
          !!e?.carst ? (
            <CheckIcon
              style={{
                color: SUCCESS_COLORS[700],
                fontSize: 10
              }}
            />
          ) : (
            <CloseIcon style={{ color: ERROR_COLORS[700], width: 10 }} />
          ),
          !!e?.creditRequest ? (
            <CheckIcon
              style={{
                color: SUCCESS_COLORS[700],
                fontSize: 10
              }}
            />
          ) : (
            <CloseIcon style={{ color: ERROR_COLORS[700], width: 10 }} />
          ),
          !!e?.isRedirect ? (
            <CheckIcon
              style={{
                color: SUCCESS_COLORS[700],
                fontSize: 10
              }}
            />
          ) : (
            <CloseIcon style={{ color: ERROR_COLORS[700], width: 10 }} />
          ),
          0 < e?.seoNumbersList?.length ? (
            <CheckIcon
              style={{
                color: SUCCESS_COLORS[700],
                fontSize: 10
              }}
            />
          ) : (
            <CloseIcon style={{ color: ERROR_COLORS[700], width: 10 }} />
          ),
          <Box style={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}>
            <Typography
              style={{ color: e.assignToFullName ? '' : ERROR_COLORS[500] }}
            >
              {e.assignToFullName || 'Нет менеджера'}
            </Typography>

            {wlTab === 2 && (
              <IconButton onClick={openManagersList(e)}>
                <EditIcon />
              </IconButton>
            )}
          </Box>,
          <AsterChip
            label={e?.saleStatus?.name || 'Активный'}
            style={{
              ...colorStatusesByCode(e?.saleStatus?.code)
            }}
          />
        ]
      })
    : []

  function closeManagersList() {
    setIsManagersListDialogOpen(false)
  }

  async function assignToManager() {
    setLoading(true)

    const { branch, firstName, lastName, username } = selectedManager

    const data = {
      assignTo: username,
      assignToFullName: `${firstName} ${lastName}`,
      branchCode: branch.code,
      id: selectedWorksheet.id
    }

    const response = await SalesService.setAssignTo(data)

    standardCheck(
      response,
      async () => {
        setLoading(false)
        closeManagersList()

        await getSaleList({
          branchCodes: [authStore.user.data.branch.code],
          limit: 10,
          offset: 0,
          statusCodes: [OKTELL]
        })
      },
      () => {}
    )

    setLoading(false)
  }

  function handleManagerSelect(event) {
    setSelectedManager(event.target.value)
  }

  const getManagers = async () => {
    try {
      const requestData = {
        isActive: true,
        limit: 300,
        offset: 0,
        projectCode: 'CS_V2',
        roleCode: 'MANAGER',
        branchCode: authStore.user.data.branch.code
      }

      const response = await AuthService.getUsers(requestData)
      setUsersList(response.data.userList)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    getManagers()
  }, [])

  return (
    <Grid item container>
      <Grid item container className={classes.wlTable}>
        <Grid item container className={classes.filterTabs}>
          {tableStatusBtns.map((item, i) => {
            const isActive = wlTab === i

            return (
              <Grid key={`table_status_btn_${i}`} item>
                <AsterButton
                  className={clsx(
                    classes.tableStatusBtn,
                    isActive ? classes.tableStatusBtnActive : ''
                  )}
                  onClick={() => setWlTab(i)}
                >
                  {item.label}

                  {isActive && (
                    <div className={classes.tableStatusCount}>
                      {wlCount || 0}
                    </div>
                  )}
                </AsterButton>
              </Grid>
            )
          })}
        </Grid>

        {wlTab === 1 && (
          <RadioGroup
            value={approveStatus}
            onChange={e => setApproveStatus(e.target.value)}
          >
            <Grid item container className={classes.filterTabs}>
              <Grid item>
                <FormControlLabel
                  className={classes.customizedCheckbox}
                  value="90"
                  control={<Radio size="small" color="primary" />}
                  label={'Согласовать скидку'}
                />
              </Grid>
              <Grid item style={{ marginLeft: 12 }}>
                <FormControlLabel
                  className={classes.customizedCheckbox}
                  value="80"
                  control={<Radio size="small" color="primary" />}
                  label={'Согласовать закрытие'}
                />
              </Grid>
            </Grid>
          </RadioGroup>
        )}

        <Grid item container>
          <StandardTable
            tableData={{
              names: columns,
              rows
            }}
            onRowClick={row =>
              router.goTo(`${HOME_PATH}${DEAL_VIEW_PATH}/${row[0]}`)
            }
            tableStyles={{
              borderRadius: 0,
              boxShadow: 'none'
            }}
          />
        </Grid>

        <Grid item container style={{ padding: '12px 24px' }}>
          <Pagination
            variant="outlined"
            shape="rounded"
            size="large"
            className={classes.pagination}
            count={pagination.count}
            page={pagination.offset ? pagination.offset : 1}
            onChange={onPaginationChange}
          />
        </Grid>
      </Grid>

      <Dialog open={isManagersListDialogOpen} onClose={closeManagersList}>
        <DialogTitle>Назначение РЛ на менеджера</DialogTitle>

        <DialogContent>
          <FormControl>
            <InputLabel>Назначить на</InputLabel>

            <Select
              label="Назначить на"
              style={{
                width: '22em'
              }}
              value={selectedManager}
              onChange={handleManagerSelect}
            >
              {usersList.length > 0 &&
                usersList.map(item => (
                  <MenuItem key={item.id} value={item}>
                    {item.lastName + ' ' + item.firstName}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </DialogContent>

        <DialogActions>
          {loading ? (
            <CircularProgress />
          ) : (
            <Button
              color="primary"
              variant="contained"
              disabled={!selectedManager}
              onClick={assignToManager}
            >
              Назначить
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Grid>
  )
}
